export const Box = [
    `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 92">
    <defs>
        <style>
            .cls-1 {
                fill: #ebf00c;
            }

            .cls-1,
            .cls-2 {
                stroke: #00328c;
                stroke-linecap: round;
                stroke-linejoin: round;
                stroke-width: 6.02px;
            }

            .cls-3,
            .cls-2 {
                fill: #00328c;
            }
        </style>
    </defs>
    <g id="BG">
        <g>
            <polygon class="cls-2" points="3.01 21.18 3.05 67.91 50.04 88.99 50 41.7 3.01 21.18" />
            <polygon class="cls-1" points="96.95 21.1 96.99 67.83 50.04 88.99 50 41.7 96.95 21.1" />
            <polygon class="cls-1" points="49.96 3.01 96.95 21.1 50 41.7 3.01 21.18 49.96 3.01" />
            <polygon class="cls-3" points="22.85 13.5 68.78 33.73 68.79 53.12 81.09 46.77 81.08 28.25 35.05 8.78 22.85 13.5" />
        </g>
    </g>
</svg>
`,
    `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 92">
    <defs>
        <style>
            .cls-1,
            .cls-2 {
                fill: #bf4030;
            }

            .cls-2,
            .cls-3 {
                stroke: #bf4030;
                stroke-linecap: round;
                stroke-linejoin: round;
                stroke-width: 6.02px;
            }

            .cls-3 {
                fill: #ebf00c;
            }
        </style>
    </defs>
    <g id="BG">
        <g>
            <polygon class="cls-2" points="3.01 21.18 3.05 67.91 50.04 88.99 50 41.7 3.01 21.18" />
            <polygon class="cls-3" points="96.95 21.1 96.99 67.83 50.04 88.99 50 41.7 96.95 21.1" />
            <polygon class="cls-3" points="49.96 3.01 96.95 21.1 50 41.7 3.01 21.18 49.96 3.01" />
            <polygon class="cls-1" points="22.85 13.5 68.78 33.73 68.79 53.12 81.09 46.77 81.08 28.25 35.05 8.78 22.85 13.5" />
        </g>
    </g>
</svg>
`,
    `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 150 130">
    <defs>
        <style>
            .cls-1 {
                fill: #00328c;
            }

            .cls-1,
            .cls-2,
            .cls-3 {
                stroke: #00328c;
                stroke-linecap: round;
                stroke-linejoin: round;
                stroke-width: 5.15px;
            }

            .cls-2 {
                fill: #bf4030;
            }

            .cls-3 {
                fill: #ebf00c;
            }
        </style>
    </defs>
    <g id="BG">
        <g>
            <polygon class="cls-1" points="16.6 44.64 16.6 100.37 75 127.42 75 71 16.6 44.64" />
            <polygon class="cls-2" points="133.4 46.68 133.4 102.41 75 127.42 75 71 133.4 46.68" />
            <polygon class="cls-3" points="88.56 3.05 146.5 25.95 133.4 46.68 75 23.32 88.56 3.05" />
            <polygon class="cls-3" points="61.44 2.58 3.5 23.45 16.6 44.64 75 23.32 61.44 2.58" />
            <polygon class="cls-3" points="75 71 89.48 90.15 147.42 65.13 133.4 46.68 75 71" />
            <polygon class="cls-3" points="75 71 60.52 89.64 2.58 62.6 16.6 44.64 75 71" />
            <g>
                <polygon class="cls-3" points="75 23.32 75 71 133.4 46.68 75 23.32" />
                <polygon class="cls-3" points="16.6 44.64 75 71 75 23.32 16.6 44.64" />
            </g>
        </g>
    </g>
</svg>
`,
    `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 150 130">
    <defs>
        <style>
            .cls-1 {
                fill: #ebf00c;
            }

            .cls-1,
            .cls-2,
            .cls-3 {
                stroke: #bf4030;
                stroke-linecap: round;
                stroke-linejoin: round;
                stroke-width: 5.15px;
            }

            .cls-2 {
                fill: #bf4030;
            }

            .cls-3 {
                fill: #00328c;
            }
        </style>
    </defs>
    <g id="BG">
        <g>
            <polygon class="cls-2" points="16.6 44.65 16.61 100.38 75.01 127.42 75 71 16.6 44.65" />
            <polygon class="cls-3" points="133.4 46.67 133.4 102.4 75.01 127.42 75 71 133.4 46.67" />
            <polygon class="cls-1" points="88.56 3.05 146.5 25.94 133.4 46.67 74.99 23.32 88.56 3.05" />
            <polygon class="cls-1" points="61.43 2.58 3.49 23.46 16.6 44.65 74.99 23.32 61.43 2.58" />
            <polygon class="cls-1" points="75 71 89.49 90.15 147.42 65.12 133.4 46.67 75 71" />
            <polygon class="cls-1" points="75 71 60.52 89.64 2.58 62.61 16.6 44.65 75 71" />
            <g>
                <polygon class="cls-1" points="74.99 23.32 75 71 133.4 46.67 74.99 23.32" />
                <polygon class="cls-1" points="16.6 44.65 75 71 74.99 23.32 16.6 44.65" />
            </g>
        </g>
    </g>
</svg>
`,
];
